module.exports = __webpack_public_path__ + "static/img/brand-logo.2b332d6e.jpg";